import React from 'react';
import PropTypes from 'prop-types';
import {Wrapper} from '../Wrapper';
import {Text} from './Text';
import {ChevronIcon} from './ChevronIcon';
import {HeaderContainer} from './HeaderContainer';
import {TranscriptContent} from './TranscriptContent';

import style from './style.module.scss';

/**
 * Transcipt:
 * This component is responsible for displaying the transcript of animation
 * transcript file path should be provided
 * transcript content visibility is could be toggled
 */

export function Transcript(props) {
  const [expanded, setExpandState] = React.useState(false);

  const toggleExpanded = () => {
    setExpandState(!expanded);
  };

  return (
    <Wrapper className={style.transcript}>
      <HeaderContainer
        className={style.transcript_titleBar}
        onClick={toggleExpanded}
        tabIndex={props.tabIndex}>
        <Text />
        <ChevronIcon expanded={expanded} />
      </HeaderContainer>
      {expanded && <TranscriptContent transcript={props.transcript} />}
    </Wrapper>
  );
}

Transcript.propTypes = {
  /**
   * specifies if component is keyboard accessible
   */
  tabIndex: PropTypes.number,
  /**
   * path containing transcript content data
   */
  transcript: PropTypes.string,
};
